import type { Scale, ScaleBand } from '../../../../types';
import { TIME } from '../../../hooks/d3/constants';
import Bottom, { BottomStrict, Time } from './Bottom';
import Left, { Band } from './Left';

const Axes = ({
  data,
  scaleX,
  scaleY,
  drawYAxis = false,
  staticBottomAxis = false,
}: {
  data: { name: string }[];
  scaleX: ScaleBand;
  scaleY: Scale;
  drawYAxis?: boolean;
  staticBottomAxis?: boolean;
}) => {
  const [x0] = scaleX.range();
  const [y0] = scaleY.range();
  const BottomAxis = scaleX.type === TIME ? Time : staticBottomAxis ? BottomStrict : Bottom;

  return (
    <>
      <Left scale={scaleY} x={x0} drawAxis={drawYAxis} />
      <BottomAxis scale={scaleX} y={y0} data={data} />
    </>
  );
};

Axes.Horizontal = ({ data, scaleX, scaleY }: any) => {
  const [x0] = scaleX.range();
  return <Band data={data} scale={scaleY} x={x0} />;
};

export default Axes;
